import React from 'react'
import { Purchase } from '../../types'

interface PurchaseStageCountProps {
    purchase: Purchase
    theme: string
}

const STAGE = [
    'Редактирование',
    'Отправка в ЕИС',
    'Подача заявок',
    'Работа комиссии',
    'Закупка завершена',
]

const STAGE_COLOR = new Map([
    ['Редактирование', '#9229EE'],
    ['Отправка в ЕИС', '#6E0AC7'],
    ['Подача заявок', '#049664'],
    ['Работа комиссии', '#63099F'],
    ['Закупка завершена', '#42036C'],
])

const STAGE_COLOR_W = new Map([
    ['Редактирование', '#9229EE'],
    ['Отправка в ЕИС', '#6E0AC7'],
    ['Подача заявок', '#049664'],
    ['Работа комиссии', '#63099F'],
    ['Закупка завершена', '#42036C'],
])

const STATUS_COLOR = new Map([
    ['Черновик', '#9951FE'],
    ['Готово', '#049664'],
    ['Готово к отправке', '#9229EE'],
    ['Отправлено', '#049664'],
    ['Подача заявок', '#049664'],
    ['Работа комиссии', '#6E0AC7'],
    ['Закупка завершена', '#515055'],
])

const PurchaseStage: React.FC<PurchaseStageCountProps> = ({
    purchase,
    theme,
}) => {
    let complete_stage = true
    return (
        <>
            <div className="relative flex flex-row w-[1710px] h-[90px] z-0 bg-[#e5e5e5] dark:bg-[#000000]">
                <svg className="flex absolute w-full h-full">
                    <line
                        x1="180"
                        y1="45"
                        x2="1545"
                        y2="45"
                        stroke={theme == 'dark' ? '#464447' : '#6A6A6A'}
                        strokeWidth="1"
                        strokeDasharray="5 5"
                    />
                </svg>
                <div className="flex w-full h-full z-20 absolute">
                    {STAGE.map((stage, index) => (
                        <div
                            key={index}
                            className="flex flex-col flex-1 justify-center items-center"
                        >
                            <div
                                className={`flex w-full h-full justify-center items-end ${complete_stage ? (stage == purchase.purchase_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : 'text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] ') : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage}
                            </div>
                            <div className="flex w-full h-full justify-center items-center">
                                <svg width="24" height="24">
                                    {complete_stage ? (
                                        stage == purchase.purchase_stage ? (
                                            <>
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="6"
                                                    fill={`${STATUS_COLOR.get(String(purchase.purchase_status))}`}
                                                />
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="8"
                                                    fill="none"
                                                    stroke={`${STATUS_COLOR.get(String(purchase.purchase_status))}55`}
                                                    strokeWidth="5"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="6"
                                                    fill={`${STAGE_COLOR.get(String(stage))}`}
                                                />
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="6"
                                                fill={
                                                    theme == 'dark'
                                                        ? '#464447'
                                                        : '#6A6A6A'
                                                }
                                            />
                                        </>
                                    )}
                                </svg>
                            </div>
                            <div
                                className={`flex w-full h-full justify-center items-start ${complete_stage ? 'text-[12.8px] text-[#181818] dark:text-[#FFFFFF] ' : ' text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]'}`}
                            >
                                {stage == purchase.purchase_stage
                                    ? purchase.purchase_status
                                    : ''}
                            </div>
                            {stage == purchase.purchase_stage
                                ? (complete_stage = false)
                                : ''}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default PurchaseStage
